import { GROUP } from "constants/types";
import { authApi, formData } from "utils";
import { setPermission } from "services/common/actions";


export const getGroupList = () => (dispatch) => {
    return authApi.get('/self/groups').then(res => {
      if(res.status === 200) {
          dispatch({
              type: GROUP.GROUP_LIST,
              payload: res.data.groups
          })
          return res
      } else if(res.status === 401) {
          dispatch(setPermission(false))
      }
    }).catch(err => {
      throw err
    })
}


export const getProductGroupByID = (id) => () => {
    return authApi.get(`groups/unique/${id}`).then(res => {
      if (res.status === 200) {
        return res
      } else {
        throw res
      }     
    }).catch(err => {
      throw err
    })
}


export const createProductGroup = (product) => () => {
    return authApi.post(`groups/create`, formData(product), { timeout: 0 })
        .then(res => {
          if (res.status === 200) {
            return res
          } else {
            throw res
          }
        }).catch(err => {
          throw err
        })
}


export const editProductGroup = (product) => () => {
    return authApi.post(`groups/edit`, formData(product), { timeout: 0 }).then(res => {
      if (res.status === 200) {
        return res
      } else {
        throw res
      }
    }).catch(err => {
      throw err
    })
}


export const deleteProductGroup = (product) => () => {
    return authApi.post(`groups/delete`, formData(product)).then(res => {
      if (res.status === 200) {
        return res
      } else {
        throw res
      }
    }).catch(err => {
      throw err
    })
}